import { render, staticRenderFns } from "./tableMenu.vue?vue&type=template&id=faf12524"
import script from "./tableMenu.vue?vue&type=script&lang=js"
export * from "./tableMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports